import { isNumber, isObject, every } from 'lodash';

import { responsiveStyles } from '@backyard-ui/styles';
import type { GridProps } from '.';
import type { ColProps } from './Col';

const isValidValue = (value: number | undefined) =>
  isNumber(value) && value > 0 && value % 1 === 0;

export function isValidSize(size: ColProps['size']) {
  if (isObject(size)) {
    return every(size, (value) => isValidValue(value));
  }

  return isValidValue(size);
}

export function getColumnSize(
  size: ColProps['size'],
  columns: GridProps['columns']
) {
  return responsiveStyles(size, (value) => ({
    // the default value comes from `Grid`
    //@ts-ignore
    $$size: `${(value / columns) * 100}%`,
  }));
}

export function getColumnOffset(
  offset: ColProps['offset'],
  columns: GridProps['columns']
) {
  if (!isValidSize(offset)) {
    return null;
  }

  return responsiveStyles(offset, (value) => ({
    // the default value comes from `Grid`
    //@ts-ignore
    marginLeft: `${(value / columns) * 100}%`,
  }));
}
